// general error message, should handle custom errors
export function showServerErrorMsg(show) {
  return {
    type: 'SHOW_SERVER_ERROR_MSG',
    serverError: show,
  };
}

export const mock = 1;
